import BtnWhatsapp from "../btnWhatsapp/BtnWhatsapp";
import Footer from "../footer/Footer";
import Nav from "../nav/Nav";
import "./QuienesSomos.css";

const ByC = () => {
  return (
    <>
      <Nav />
      <div className="quienes-somos">
        <h2>BASES Y CONDICIONES DEL SERVICIO</h2>
        <p>
          Dejar el dispositivo en reparación SIGNIFICA ACEPTAR TODAS LAS
          CONDICIONES AQUÍ DESCRIPTAS.{" "}
        </p>
        <p>
          * La comunicación, la aceptación y/o el rechazo de los presupuestos
          entre el taller y el cliente podrá realizarse por diferentes medios
          tales como mensajería instantánea digital (WhatsApp, Telegram, etc),
          correo electrónico, presencialmente con su documento en mano, o vía
          apartado online específico en el software de gestión Orden de
          Reparación© ingresando con el número de Orden y Documento. Los
          presupuestos no confirmados por el cliente se actualizarán cada 7 días
          salvo que se exprese otro plazo en un documento o propuesta. * Para
          retirar el dispositivo es imprescindible presentar el talón
          (comprobante) de Orden de Reparación© que se le entregó al recibir el
          equipo (salvo que haya realizado el proceso de ingreso online); a ello
          debe adjuntar el comprobante de abono correspondiente a los servicios
          efectuados y presentar el documento de identidad declarado en la
          orden. * En todas las reparaciones existen riesgos que pueden suceder
          al intentar hacer la reparación solicitada, pudiendo ocasionar un daño
          y/o inhabilitación el propio componente a reparar, el de otro
          componente o la integridad total del dispositivo; los riesgos son
          avisados al cliente previo a la recepción del equipo o al identificar
          el problema quedando en el cliente la potestad de aceptar o no la
          reparación reconociendo el riesgo que corre su equipo y el costo
          asociado a la solución del mismo. * Existen reparaciones mínimas y
          necesarias incluso para realizar un diagnóstico de rutina, estas
          reparaciones se harán de forma automática y sin previo aviso, quedando
          dentro del concepto de diagnóstico, el cual posee un costo y varía
          según los componentes afectados. Consulte en el taller o al técnico
          cual es dicho monto actualizado al día de la fecha antes de realizar
          el ingreso de su dispositivo. *El cliente tiene la potestad de aceptar
          o rechazar todos los presupuestos que se le presenten, tanto por la
          falla principal como los adicionales descubiertos en el diagnóstico,
          pudiendo aceptar uno, algunos o todos, pero entendiendo que son
          presupuestos independientes. Cuando un presupuesto es aceptado se
          considera tal como un compromiso y se llevan a cabo, siendo imposible
          cancelarlos una vez iniciados. * Todo trabajo solicitado como
          “urgente”, tendrá un costo adicional y está sujeto a disponibilidad
          horaria del taller y/o del técnico como también de la disponibilidad
          en los proveedores de los componentes necesarios para la reparación
          pudiéndose no reparar en el tiempo estipulado. * Toda reparación
          efectuada tiene una garantía de 30 días según ley 24.240 (Defensa del
          Consumidor), contados desde la fecha de aviso de reparado, quedando
          excluidas las fallas por: mala manipulación, roturas o golpes,
          sobretensión o evidencia de residuos líquidos, humedad, o si el
          dispositivo fue intervenido por un tercero. Los dispositivos que
          ingresan mojados, no son sujetos a garantía. Las reparaciones de
          software carecen de garantía por la cantidad de virus que existen en
          internet, opciones de configuración y/o apps instalables, como también
          por el uso que se le dará. Toda garantía queda en potestad del
          servicio técnico darle efecto a la misma, tras revisión mínima de
          48hs. siempre y cuando se presente talón de la Orden de Reparación©
          previa y/o boletas de pagos. * Todos los dispositivos ingresados se
          considerarán fuera de garantía (salvo los casos estipulados y
          acordados) y por tanto la reparación se facturará de acuerdo con las
          tarifas vigentes. En caso que se invoque la garantía de un equipo
          nuevo, se verificará si corresponde tomarlo o derivarlo al fabricante
          y/o “servicio oficial” de la marca para que ejecute la garantía que se
          encuentra adjunta al dispositivo cuando lo compró. * En caso de
          ejecutarse una garantía, todo costo ocasionado por el traslado del
          dispositivo, quedan a cargo del Servicio Técnico según Ley 24.410 (Ley
          del Consumidor). En caso que no ingrese o no aplique una garantía, los
          costos por traslados quedan a cargo del cliente. * El cliente declara
          ser el dueño legítimo del dispositivo que deja a reparar, siendo el
          cliente el responsable absoluto de cualquier reclamación de legítimo
          dueño y/o por adulteración que el mismo presente; desligando
          completamente al servicio técnico involucrado en la reparación del
          dispositivo de toda responsabilidad. * El servicio técnico no se hace
          responsable de los datos o información contenida en los dispositivos
          puestos a su disposición, ni de cualquier supuesta pérdida de datos en
          cualquiera de las unidades de almacenamiento. También garantiza total
          confidencialidad sobre los datos y/o archivos sensibles (contraseñas,
          claves, tokens, fotos, videos, documentos, etc) que puedan encontrarse
          dentro de la rutina de testeos básicos o específicos del dispositivo a
          reparar. De ser necesario realizar un BackUp (copia de seguridad) el
          cliente deberá solicitar dicho servicio y especificar en qué
          directorios, cuentas y/o servicios quiere realizar el BackUp, el cual
          tendrá un costo en concepto por mano de obra. Solo haremos una copia
          de seguridad, restauración de datos, sincronización a internet,
          movimiento de datos o eliminación de información, únicamente cuando
          sea el objetivo de la reparación solicitada por el cliente; toda lo
          obtenido es entregado al cliente sin conservar ni generar copias
          adicionales a la que se le entrega al cliente. Quedando sujeto a la
          ley 25.326 (Protección de datos personales). * El cliente libera de
          toda responsabilidad al taller, al técnico y/o cualquier involucrado
          en la reparación de su dispositivo por cualquier tipo de falla en
          dispositivos que son recepcionados: sin encender, no se encuentren
          operativos, estén mojados, estén sin carga y/o que tengan algún
          problema de software o hardware. En la orden de reparación se deja
          constancia en las condiciones que ingresa el dispositivo a nuestros
          centros de reparación y se escribe literalmente del problema que
          describa el cliente. * Una vez que el taller y/o técnico notifique el
          retiro del dispositivo, y no es retirado en los siguientes 90 días, se
          actualizarán los montos de la reparación al día del retiro, así
          también se aplicará un monto por guarda del dispositivo (Artículo 790
          del Código Civil y Comercial). Pasados los 90 días el propietario tras
          la intimación mediante los medios de contacto proporcionados en la
          recepción, perderá todo derecho ante el dispositivo, considerando este
          como abandonado. (Basado en Artículo 1947 del Código Civil y
          Comercial, Apropiación).
        </p>
        <p>
          En TecniPlus+, nos comprometemos a brindarte soluciones claras,
          honestas y profesionales en cada reparación.
        </p>
      </div>
      <Footer />
      <BtnWhatsapp />
    </>
  );
};

export default ByC;
